import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService, provideTranslateService } from '@ngx-translate/core';

import { inject, EnvironmentProviders, provideAppInitializer, makeEnvironmentProviders } from '@angular/core';

import { environment } from '@/environments/environment';

export function provideAppTranslation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: environment.fallbackLocale,
      lang: environment.locale,
    }),

    provideAppInitializer(() => {
      const translate = inject(TranslateService);

      return translate.use(environment.locale);
    }),
  ]);
}
